import { useEffect } from 'react'
import { showNotification } from 'summon-ui'
import { erc20Abi, formatUnits } from 'viem'
import { useAccount, useReadContracts } from 'wagmi'
import { TENANT_CONFIG } from '@config'

const DEFAULT_LOW_BALANCE_MESSAGE = 'You must have some USDC in your wallet to mint'
const DEFAULT_AMOUNT = 1

interface ReturnType {
  hasLowBalance: boolean
  userBalance: number
}

interface Props {
  contract: `0x${string}` | undefined
  enabled: boolean
  showToast?: boolean
  message?: string
  amount?: number
  watch?: boolean
}

const useUserHasLowBalance = ({ contract, enabled, message, amount, showToast = true }: Props): ReturnType => {
  const { address } = useAccount()
  const { data } = useReadContracts({
    allowFailure: false,
    contracts: [
      {
        address: contract,
        abi: erc20Abi,
        functionName: 'balanceOf',
        chainId: TENANT_CONFIG.network.id,
        args: [address!]
      },
      {
        address: contract,
        abi: erc20Abi,
        chainId: TENANT_CONFIG.network.id,
        functionName: 'decimals'
      }
    ]
  })
  const userBalance = data ? formatUnits(data[0], data[1]) : 0
  const hasLowBalance = Number(userBalance) < (amount || DEFAULT_AMOUNT)

  useEffect(() => {
    if (hasLowBalance && showToast && enabled) {
      showNotification({
        variant: 'danger',
        message: message || DEFAULT_LOW_BALANCE_MESSAGE
      })
    }
  }, [hasLowBalance, enabled, showToast])

  return { hasLowBalance, userBalance: Number(userBalance) || 0 }
}

export default useUserHasLowBalance
